export const language: any ={
    LabelLogin:"Đăng nhập",
    LabelForgotPw:"Tìm mật khẩu",
    LabelSignUp:"Đăng kí hội viên",
    LabelRememberMe:"Duy trì trạng thái đăng nhập",
    Or:"Hoặc",
    Email:"Email",
    Password:"Mật khẩu",
    LangKo:"한국어",
    LangEn:"영어",
    LangVi:"베트남어",
    LabelCondition:"Đồng ý điều khoản",
    FullAgreement:"Đồng ý tất cả",
    Next:"Tiếp theo",
    PrivacyPolicy:`Chính sách xử lý thông tin cá nhân <label class="text-[#ff6741]">(Bắt buộc)</label>`,
    TermOfUse:`Điều khoản sử dụng <span class="text-[#ff6741]">(Bắt buộc)</span>`,
    VerifyPassword:"Xác nhận mật khẩu",
    PlaceHolderPassword:"Nhập trên 8 kí tự tiếng anh + số + kí tự đặc biệt",
    DuplicateCheck:`Check trùng lặp`,
    LabelIdEmail:"ID (email)",
    GN_02_MSG_01:"Phiên bản ứng dụng của bạn đã cũ. Vui lòng nâng cấp để tiếp tục sử dụng.",
    AU_02_MSG_02:"Email đã được đăng ký trên hệ thống, vui lòng sử dụng email khác.",
    AU_02_MSG_03:"Email khả dụng.",
    AU_02_MSG_01:"Vui lòng nhập email đúng định dạng.",
    AU_01_MSG_01:"ID hoặc mật khẩu không chính xác. Vui lòng thử lại.",
    AU_02_MSG_04:"Vui lòng kiểm tra email khả dụng.",
    AU_02_MSG_05:"Vui lòng nhập mật khẩu ít nhất 8 ký tự, bao gồm ký tự tiếng anh, ký tự số và ký tự đặc biệt.",
    AU_02_MSG_06:"Xác nhận mật khẩu không trùng khớp.",
    AU_03_MSG_01:"Vui lòng nhập đúng định dạng email.",
    AU_03_MSG_02:"Email chưa được đăng ký trên hệ thống.",
    AU_03_MSG_04:"※ Đã gửi mã xác thực đến email đã đăng ký.",
    LabelRegisterComplete:"Đã hoàn thành đăng kí hội viên!",
    LabelLoginToUseService:"Vui lòng sử dụng dịch vụ sau khi đăng nhập.",
    LabelDontRememberPassword:"Bạn không nhớ mật khẩu đúng không ?",
    LabelYouCanFindEmail:"Bạn có thể tìm lại mật khẩu thông qua chứng thực email.",
    LabelPasswordTemporarySendToEmail:"※ Đã gửi mật khẩu tạm thời đến email đã đăng kí hội viên.",
    SendVerifyNumber:"Gửi mã chứng thực",
    LabelCheckYourEmailForTemporaryPassword:"Vui lòng xác nhận mật khẩu tạm thời ở email",
    PlaceHolderTemporaryPassword:"Nhập mật khẩu tạm thời",
    LabelTemporaryPassword:"Mật khẩu tạm thời",
    // LabelYouCanResendItAfter:`비밀번호를 못받으셨나요? {time} 후 재전송 할 수 있습니다.`,
    LabelDidntReceiveYourPassword:`Bạn không nhận được mật khẩu ? `,
    LabelYouCanResendItAfter:`Có thể gửi lại sau`,
    LabelYouCanResendAgain:`Có thể gửi lại.`,
    Confirm:`Xác nhận`,
    Resend:`Gửi lại`,
    LabelResetPassword:"Cài lại mật khẩu",
    NewPassword:"Mật khẩu mới",
    ConfirmNewPassword:"Xác nhận mật khẩu mới",
    PlaceHolderConfirmPassword:"Xác nhận mật khẩu",
    CurrentPassword:"Mật khẩu hiện tại", //menu
    LanguageSetting:"Thiết lập ngôn ngữ", //menu
    LeaveMembership:"Thoát hội viên", //menu
    LabelConfirmPasswordToLeaveMemberShip:"Xác nhận mật khẩu để tiến hành thoát hội viên", //menu
    LabelConfirmPasswordMeansYouAgreeAllContent:"Xác nhận mật khẩu đồng nghĩa với việc bạn đã kiểm tra tất cả nội dung hướng dẫn và đồng ý chúng. ", //menu
    LabelCancelMembership:"Thoát hội viên", //menu
    LabelBeforeLeaveYouCheckedContent:"Trước khi thoát hội viên vui lòng kiểm tra hướng dẫn bên dưới và chọn vào đồng ý.", //menu
    LabelAfterLeaveAllInfoWillRemove:"Sau khi thoát hội viên, tất cả thông tin hội viên và lịch sử sử dụng sẽ bị xóa và không thể phục hồi lại.", //menu
    LabelIHaveReadAndAgreeContent:"Tôi đã kiểm tra tất cả nội dung hướng dẫn và đồng ý với chúng.", //menu
    ToUnsubscribe:"Thoát hội viên", //menu
    LabelWouldYouWantLogout:"Bạn có muốn đăng xuất không ?", //menu
    ChangePassword:"Thay đổi mật khẩu", //menu
    Menu:"Menu", //menu
    MenuLanguageSettings:"Thiết lập ngôn ngữ", //menu
    MenuPrivacyPolicy:"Chính sách xử lý thông tin cá nhân", //menu
    MenuLogout:"Đăng xuất", //menu
    MenuLeaveMembership:"Thoát hội viên", //menu
    LabelAreYouSureLeaveMembership:"Bạn thật sự muốn thoát hội viên ?", //menu
    LabelIfLeaveMembershipAllInfoWillRemove:"Nếu thoát hội viên, thông tin tài khoản sẽ bị xoá và không thể phục hồi.", //menu
    LabelPrivacyPolicy:"Chính sách xử lý thông tin cá nhân",
    LabelTermOfUse: "Điều khoản sử dụng",
    MI_02_MSG_01 : "Mật khẩu hiện tại không chính xác.",
    LabelModalLogin: `Vui lòng đăng nhập hoặc đăng kí tài khoản <br/> để tiếp tục sử dụng chức năng này.`,
    LabelIdLogin: "ID Đăng nhập",
    LabelSnsApple: "Đăng nhập bằng Apple",
    LabelSnsFacebook: "Đăng nhập bằng Facebook",
    LabelSnsGoogle: "Đăng nhập bằng Google",
    LabelItemLogin: "Đăng nhập hoặc đăng kí tài khoản để <br/>khám phá nhiều tính năng thú vị cùng <br/>Hey Cooker!",
    LabelSnsEmail: "Đăng nhập bằng Email",
    LoadingLogin: "Vui lòng chờ một chút.",
    MenuNotificationSettings: "Cài đặt thông báo", //menu
}

